import HStack from '~/common/components/Stacks/HStack';
import VStack from '~/common/components/Stacks/VStack';
import Text from '~/common/components/Texts/Text';

type FormulaBreakdownProps = {
  formulas?: {
    BreakDown?: {
      Name: string;
      Value: string[];
    }[];
  };
};

export default function FormulaBreakdown({
  formulas,
}: Readonly<FormulaBreakdownProps>) {
  return (
    <VStack spacing={4} sx={{ textAlign: 'left' }}>
      {formulas?.BreakDown.map((formula) => (
        <HStack key={formula.Name} sx={{ alignItems: 'start' }}>
          <Text fontSize="0.875rem" fontWeight="700">
            {formula.Name}:
          </Text>
          <VStack sx={{ textAlign: 'left' }}>
            {formula.Value.map((line) => (
              <Text key={line} fontSize="0.875rem" fontWeight="400">
                {line}
              </Text>
            ))}
          </VStack>
        </HStack>
      ))}
    </VStack>
  );
}
